var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Total Inventory")]),_vm._v(" Coming Soon ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }